import { render, staticRenderFns } from "./PrefCitySelect.vue?vue&type=template&id=794516d4&scoped=true&"
import script from "./PrefCitySelect.vue?vue&type=script&lang=js&"
export * from "./PrefCitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794516d4",
  null
  
)

export default component.exports